/**
 * Format date to local string
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString();
};

/**
 * Format date to time only
 */
export const formatTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleTimeString();
};

/**
 * Get status badge color
 */
export const getStatusColor = (status) => {
  const colors = {
    pending: 'warning',
    processing: 'info',
    completed: 'success',
    failed: 'danger'
  };
  return colors[status?.toLowerCase()] || 'secondary';
};

/**
 * Handle API error
 */
export const getErrorMessage = (error) => {
  if (error.response) {
    return error.response.data?.error || error.response.data?.message || 'An error occurred';
  }
  if (error.request) {
    return 'No response from server';
  }
  return error.message || 'An unexpected error occurred';
};

/**
 * Get time elapsed since date
 */
export const getTimeElapsed = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min ago`;
  
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  
  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
};
